import {TrashIcon} from '@/components/svg/TrashIcon';
import {Button, Tooltip} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';
import {LigneDePanierCommands} from 'ff-common/src/hooks/ligneDePanier/use-ligne-de-panier-commands';

export const SupprimerErrorButton: React.FC<{
  // probleme: LigneProblem,
  // ligneDePanier: State<LigneDePanierDesc>,
  commands: LigneDePanierCommands;
  onClose?: () => void;
  submittingOrRefreshing?: boolean;
  code_article: string;
  primaryColor?: string;
}> = ({
  commands,
  onClose,
  submittingOrRefreshing,
  // code_article,
  primaryColor,
}) => {
  const {t} = useTranslation();
  const {somethingSubmitting, supprimer} = commands;

  const handleClick = async () => {
    supprimer.submit({});
    onClose?.();
  };
  return (
    <Tooltip label={t('ligne_produit.indisponible.tooltip_rupture_totale')}>
      <Button
        {...(primaryColor
          ? {bg: primaryColor, color: 'white', _hover: {opacity: 0.85}}
          : {colorScheme: 'blue'})}
        isDisabled={somethingSubmitting || submittingOrRefreshing}
        onClick={handleClick}
      >
        <TrashIcon />
      </Button>
    </Tooltip>
  );
};
